@if ((loading$ | async) === false) {
  <crm-newsletter-form
    [data]="data"
    [canDelete]="(form$ | async)?.isEdit"
    [canWrite]="(form$ | async)?.canWrite"
    [isModal]="true"
    [emails]="emails"
    [arraySms]="arraySms"
    [externalUsers]="externalUsers"
    [recipientUsers]="recipientUsers"
    [directions]="directions"
    (save)="saveNewsletter($event)"
    (delete)="deleteNewsletter()"></crm-newsletter-form>
}

@if (loading$ | async) {
  <crm-spinner></crm-spinner>
}
